import React, { useState } from 'react'
import {
  HeaderWrapper,
  IconsWrapper,
  InfoWrapper,
  Line,
  SubTitle,
  Title,
  TitleWrapper,
  TrashButton,
  EditButton,
  InfoBody
} from './styles'
import { Modal } from 'antd'
import { Text } from '../../../constants/TextConstants'
import parse from 'html-react-parser'
import { dateFormat } from '../../../utils/utils'
import PropTypes from 'prop-types'
import { ModalExperience } from '../Modals/Experience'
import { IndustrySector } from '../../../constants/constants'

export const InfoBox = ({ data, setModelProfile, indexToModify, isSavedChange, canSelectOnePage = true }) => {
  const [openModal, setOpenModal] = useState(false)
  const [openModalDelete, setOpenModalDelete] = useState(false)

  const removeItem = () => {
    setModelProfile((prevState) => {
      const arrayExperience = prevState.professional_experience.filter((item) => item !== data)
      return { ...prevState, professional_experience: arrayExperience }
    })
    setOpenModalDelete(false)
    isSavedChange(true)
  }

  return (
    <>
      <InfoWrapper>
        <Line />
        <HeaderWrapper>
          <TitleWrapper>
            <Title>{data.project_rol}</Title>
            <SubTitle>{dateFormat(data.ended_date, data.started_date)}</SubTitle>
          </TitleWrapper>
          <IconsWrapper>
            <EditButton data-testid='editButton' size='26' title='Edit Item' onClick={() => setOpenModal(true)} />
            <TrashButton
              data-testid='removeButton'
              size='15'
              title='Delete Item'
              onClick={() => setOpenModalDelete(true)}
            />
          </IconsWrapper>
        </HeaderWrapper>
        <InfoBody>{data.project_name}</InfoBody>
        <SubTitle>{data.description}</SubTitle>
      </InfoWrapper>
      <ModalExperience
        data={data}
        openModal={openModal}
        setOpenModal={setOpenModal}
        setModelProfile={setModelProfile}
        indexToModify={indexToModify}
        mode='update'
        skillName={IndustrySector}
        isSavedChange={isSavedChange}
        canSelectOnePage={canSelectOnePage}
      />

      <Modal
        title={Text.DeleteItem}
        open={openModalDelete}
        width='300px'
        okText={'Delete'}
        maskClosable={false}
        keyboard={false}
        onOk={() => removeItem()}
        onCancel={() => setOpenModalDelete(false)}>
        <Title>{Text.Alert}</Title>
        <br />
        {parse(Text.DeleteMessage)}
      </Modal>
    </>
  )
}

InfoBox.propTypes = {
  data: PropTypes.object,
  setModelProfile: PropTypes.func,
  indexToModify: PropTypes.number,
  isSavedChange: PropTypes.func,
  canSelectOnePage: PropTypes.bool
}
